import nlp from "compromise";
import { environment, nextJsEndpoint } from "../utils/constants";

export const markTextSentences = (text: string) => {
  if (!text) {
    return {
      sentences: [],
      markedOpinion: "",
    };
  }
  // @ts-ignore
  const sentences: string[] = nlp(text).map((s) => s.text()) as string[];
  const markedOpinion = sentences.map((s, i) => `LINE ${i}: ${s}`).join("\n");

  return {
    sentences,
    markedOpinion,
  };
};

export const turnMessageRefsIntoLinks = (
  messageContent: string,
  opinionSentences: string[],
  caseName: string | null,
  opinionId: string
) => {
  try {
    if (opinionSentences.length === 0) {
      console.log("No opinion sentences found");
      return messageContent;
    }

    const newContent = replaceRefsWithLinks(opinionSentences, messageContent, caseName, opinionId);

    return newContent;
  } catch (error) {
    console.error("Error processing messages -- replaceRefsWithLinks:", error);
  }
  return messageContent;
};

/**
 * Replaces [lines] syntax in a completion with the corresponding sentences
 * Syntax could be in the forms [lines="1"], [lines="1-2"], [lines="1-2, 6-9"], [lines="1, 4, 6-9"], etc.
 */
export const replaceRefsWithLinks = (
  sentences: string[],
  content: string,
  caseName: string | null,
  opinionId: string
): string => {
  try {
    // Regex to match [lines="<capturedGroup>"]
    const regex = /\[?lines?=([^\]]+)\]?/g;

    return content.replace(regex, (match) => {
      const ranges = match.match(/(\d+)(?:-(\d+))?/g);

      if (!ranges) {
        return match;
      }

      const links = ranges
        .map((range) => {
          if (range.includes("-")) {
            const [start, end] = range.split("-").map(Number);
            return getLinkFromMatch(sentences, start, end || undefined, caseName, opinionId);
          } else {
            const line = Number(range);
            return getLinkFromMatch(sentences, line, undefined, caseName, opinionId);
          }
        })
        .filter(Boolean); // Filter out undefined links

      return links.join(", ") || match;
    });
  } catch (error) {
    console.error("Error replacing [lines] with links:", error);
    return content;
  }
};

/**
 * turn line matches into a link
 */
const getLinkFromMatch = (
  sentences: string[],
  startLine: number,
  endLine: number | undefined,
  caseName: string | null,
  opinionId: string
) => {
  const bindLineNumber = (lineNumber: number) => {
    return Math.max(0, Math.min(lineNumber, sentences.length - 1));
  };

  try {
    const startIndex = bindLineNumber(startLine);
    const endIndex = bindLineNumber(endLine ? endLine : startLine + 1);
    const quote = sentences
      .slice(startIndex, endIndex)
      .map((sentence) => sentence.trim())
      .join(". ");
    const alphanumericText = quote.replace(/[^a-zA-Z0-9]/g, "");
    const link = getOpinionLink(caseName, opinionId, alphanumericText);

    return `<a href="${link}" quote="${alphanumericText}">[source]</a>`;
  } catch (error) {
    console.error("Error getting link from match:", error);
    return null;
  }
};

const kebabCase = (x: string) => {
  return x
    .replace(/[^a-zA-Z0-9\s]/g, "") // only keep the alphanumeric characters and spaces, remove all other characters
    .replace(/([a-z])([A-Z])/g, "$1-$2")
    .replace(/[\s_]+/g, "-")
    .toLowerCase();
};

export function getOpinionLink(caseName: string | null, opinionId: string, quote: string | null) {
  const url = nextJsEndpoint[environment];
  const slug = getDocumentRoute(caseName, opinionId);
  let link = `${url}${slug}`;
  if (quote) {
    link += `?quote=${encodeURIComponent(quote.slice(0, 300))}`;
  }
  return link;
}

export const getDocumentRoute = (caseName: string | null | undefined, opinionId: string) => {
  const formattedCaseName = caseName ? `${kebabCase(caseName)}-` : "";
  return `/document/${formattedCaseName}${opinionId}`;
};
